import { render, staticRenderFns } from "./BotonYListaSubirArchivos.vue?vue&type=template&id=5cf03675&scoped=true"
import script from "./BotonYListaSubirArchivos.vue?vue&type=script&lang=js"
export * from "./BotonYListaSubirArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf03675",
  null
  
)

export default component.exports